// Copyright © Aptos Foundation
// SPDX-License-Identifier: Apache-2.0

export const DEFAULT_MAX_GAS_AMOUNT = 200000;
// Transaction expire timestamp
export const DEFAULT_TXN_EXP_SEC_FROM_NOW = 20;
